//Physics experimets data
export const class9 = [
    {
        id:1,
        title:"Archimedes Principal",
        img:"https://media.istockphoto.com/photos/archimede-italian-stamp-picture-id177513676?s=612x612",
        description:"Archimedes’ principle, physical law of buoyancy, discovered by the ancient Greek mathematician and inventor Archimedes, stating that any body completely or partially submerged in a fluid (gas or liquid) at rest is acted upon by an upward, or buoyant, force, the magnitude of which is equal to the weight of the fluid displaced by the body.",
        videolink:"https://www.youtube.com/watch?v=_p-hwElkrlk",
        explink:"https://simmer.io/@Buoyancy/buoyancy",
        theory:"https://lakshya3119.github.io/Phy1/All-3%20Experiment-HTML%20-fILE-CLASS-9-PHYSICS/All-3%20Experiment-HTML%20-fILE-CLASS-9-PHYSICS/index.html"
    },
    {
        id:2,
        title:"Speed of Sound",
        img:"https://images.pexels.com/photos/1649771/pexels-photo-1649771.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        description:"Sound, a mechanical disturbance from a state of equilibrium that propagates through an elastic material medium. A purely subjective definition of sound is also possible, as that which is perceived by the ear, but such a definition is not particularly illuminating and is unduly restrictive, for it is useful to speak of sounds that cannot be heard by the human ear.",
        videolink:"https://youtu.be/zstmGnaaaCI",
        explink:"",
        theory:"https://www.sjsu.edu/faculty/beyersdorf/Phys50lab/Manual/15-EXPERIMENT%2012.pdf"
    },
    {
        id:3,
        title:"Density of solid",
        img:"https://images.pexels.com/photos/220237/pexels-photo-220237.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
        description:"The ratio of the mass of a substance to its volume is known as the mass density or, simply, the density of the substance. Density is expressed in units of mass per volume, such as g/mL or kg/m3. Because the density of a substance does not depend on the amount of substance present, density is an “intensive property”.",
        videolink:"https://youtu.be/md-Qk_g9NEo",
        explink:"",
        theory:"https://lakshya3119.github.io/Phy1/All-3%20Experiment-HTML%20-fILE-CLASS-9-PHYSICS/All-3%20Experiment-HTML%20-fILE-CLASS-9-PHYSICS/index.html"
    }

]

export const class10 = [
    {
        id:1,
        title:"Reflection",
        img:"https://images.pexels.com/photos/220429/pexels-photo-220429.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        description:"Reflection is the change in direction of a wavefront at an interface between two different media so that the wavefront returns into the medium from which it originated. Common examples include the reflection of light, sound and water waves. The law of reflection says that for specular reflection the angle at which the wave is incident on the surface equals the angle at which it is reflected.",
        videolink:"https://youtu.be/ETF2-Zz3J18",
        explink:"",
        theory:"https://www.physicsclassroom.com/getattachment/lab/refln/rm1tg.pdf"
    },
    {
        id:2,
        title:"Ohm’s Law",
        img:"https://www.pexels.com/photo/blue-electric-sparks-68173/",
        description:"An electric circuit is formed when a conductive path is created to allow electric charge to continuously move. This continuous movement of electric charge through the conductors of a circuit is called a current, and it is often referred to in terms of “flow,” just like the flow of a liquid through a hollow pipe.",
        videolink:"https://youtu.be/E_DsqQARbFg",
        explink:"",
        theory:"https://sandyco.weebly.com/uploads/1/5/6/8/15687572/6.verification_of_ohms_law.pdf"
    },
    {
        id:3,
        title:"Velocity of Pulse",
        img:"https://www.pexels.com/photo/medical-stethoscope-with-red-paper-heart-on-white-surface-4386467/",
        description:"Pulse wave velocity (PWV) is the velocity at which the blood pressure pulse propagates through the circulatory system, usually an artery or a combined length of arteries",
        videolink:"https://youtu.be/rbjaLMCukJo",
        explink:"",
        theory:"https://lakshya3119.github.io/Phy1/All-3%20Experiment-HTML%20-fILE-CLASS-9-PHYSICS/All-3%20Experiment-HTML%20-fILE-CLASS-9-PHYSICS/index3.html"
    }
]

export const class11 = [
    {
        id:1,
        title:"Friction",
        img:"https://www.pexels.com/photo/hitachi-white-black-angle-grinder-162534/",
        description:"Friction is a force between two surfaces that are sliding, or trying to slide, across each other. For example, when you try to push a book along the floor, friction makes this difficult. Friction always works in the direction opposite to the direction in which the object is moving, or trying to move",
        videolink:"https://youtu.be/ON8h8Tg65Sc",
        explink:"",
        theory:"http://www.umsl.edu/~physics/files/pdfs/Mechanics%20Lab/Exp5.Friction.pdf"
    },
    {
        id:2,
        title:"Refraction",
        img:"https://www.pexels.com/photo/glass-with-refraction-pattern-in-darkness-4946525/",
        description:"Refraction is the bending of light (it also happens with sound, water and other waves) as it passes from one transparent substance into another. This bending by refraction makes it possible for us to have lenses, magnifying glasses, prisms and rainbows",
        videolink:"https://youtu.be/el8AUeZaljw",
        explink:"",
        theory:"https://sandyco.weebly.com/uploads/1/5/6/8/15687572/refraction_through_glassslab1.pdf"
    },
    {
        id:3,
        title:"Magnetism And Matter",
        img:"https://www.pexels.com/photo/snow-light-sea-landscape-6890374/",
        description:"Magnetism is the force exerted by magnets when they attract or repel each other. Magnetism is caused by the motion of electric charges. Every substance is made up of tiny units called atoms. Each atom has electrons, particles that carry electric charges.",
        videolink:"https://youtu.be/M1hMHylYCHw",
        explink:"",
        theory:"http://www.phys.ttu.edu/~batcam/MagneticFields.pdf"
    }

]

export const class12 = [
    {
        id:1,
        title:"Resistance",
        img:"https://www.pexels.com/photo/black-transistor-beside-capacitor-163100/",
        description:"Resistance is a measure of the opposition to current flow in an electrical circuit. Resistance is measured in ohms, symbolized by the Greek letter omega (Ω). Ohms are named after Georg Simon Ohm (1784-1854), a German physicist who studied the relationship between voltage, current and resistance.",
        videolink:"https://youtu.be/KFxTH0Y7C64",
        explink:"",
        theory:"http://www.umsl.edu/~physics/files/pdfs/Electricity%20and%20Magnetism%20Lab/Exp4.SeriesParallel.pdf"
    },
    {
        id:2,
        title:"Focal length",
        img:"https://www.pexels.com/photo/photo-of-magnifying-glass-on-top-of-braille-7188802/",
        description:", the focal length of a lens is an optical property of the lens. It measures the distance, in millimetres, between the optical centre of the lens and the camera’s sensor (or film plane). It is determined with the camera focused to infinity. Lenses are named by their focal length, and you can find this information on the barrel of the lens. ",
        videolink:"https://youtu.be/6C3UXLwvf-M",
        explink:"",
        theory:"https://ncert.nic.in/pdf/publication/sciencelaboratorymanuals/classXII/physics/lelm309.pdf"
    },
    {
        id:3,
        title:"Semi conductors",
        img:"https://www.pexels.com/photo/green-circuit-board-with-clear-glass-case-163073/",
        description:"Semiconductors are materials which have a conductivity between conductors (generally metals) and nonconductors or insulators (such as most ceramics). Semiconductors can be pure elements, such as silicon or germanium, or compounds such as gallium arsenide or cadmium selenide.",
        videolink:"https://youtu.be/CWXuXVx71Yk",
        explink:"",
        theory:"https://uotechnology.edu.iq/dep-laserandoptoelec-eng/English/laboratory/2/electronic1/semiconductor%20diode%20characteristics%20.pdf"
    }

]



